import React from "react";
import Select from "react-select";
import { withStyles } from "@material-ui/core";
import ArrowDropDown from "@material-ui/icons/KeyboardArrowDown";
import Clear from "@material-ui/icons/CancelOutlined";
import { isEqual } from "lodash/lang";

const style = theme => ({
    Dropdown:{
        backgroundColor: theme.ModalBGColor,
        color: theme.TextColor
    },
    reactSelect:{
        display: "inline-block",
        paddingLeft: 8,
        '& .select__control':{
            minWidth: 140,
            maxWidth: "100%",
            backgroundColor: "transparent",
            minHeight: 24,
            boxSizing:"border-box",
            borderRadius: 0,
            marginTop:6,
            border:"none",
            borderBottom: `1px solid ${theme.iconColor}`,
            fontSize: 12,
            cursor: "pointer",
            '&:hover,&.select__control--is-focused':{
                boxShadow: "none",
                // borderRadius: 2,
                borderBottom: `1px solid ${theme.iconColor}`,
            },
            '& .select__value-container':{
                minHeight: 32,
                height:"fit-content",
                overflow:"visible",
                color: theme.TextColor,
                padding:"0px 8px",
                '& .select__input':{
                    height:22,
                    color: theme.TextColor,
                    '&>input':{
                        height:22
                    }
                },
                '&>div':{
                    margin:0
                },
                '&>.select__multi-value':{
                    margin:2,
                    backgroundColor: theme.HeaderSelectedText,
                    '&>div':{
                        color:"white",
                        padding: 4
                    },
                    '& .select__multi-value__remove':{
                        padding: "4px 0",
                        cursor: "pointer",
                        '&:hover':{
                            backgroundColor: theme.HeaderSelectedText
                        }
                    }
                }
            },
            '& .select__single-value':{
                color: "inherit"
            },
            '& .select__indicators':{
                height: 24,
                '& .select__indicator':{
                    padding: 5,
                    height: 24,
                },
                '& .select__indicator-separator':{
                    height: 24,
                    margin: 0,
                    display: "none"
                }
            }
        },
        '& .select__menu':{
            margin: 0,
            maxHeight: 140,
            borderRadius: 2,
            border: `1px solid ${theme.iconColor}`,
            '& .select__menu-list': {
                maxHeight: 138,
                borderRadius: 2,
                fontSize:12,
                backgroundColor: theme.ModalBGColor,
                color: theme.TextColor
            },
            '& .select__option--is-focused':{
                backgroundColor: theme.HighlightColor,
                cursor: "pointer",
            },
            '& .select__option--is-selected':{
                backgroundColor: theme.HeaderSelectedText
            }
        }
    },

    iconStyle:{
        color: theme.iconColor,
        cursor: "pointer"
    },

    multiValueApplied:{
        '& .select__control':{
            borderBottom:`1px solid ${theme.HeaderSelectedText}`,
            '&:hover,&.select__control--is-focused':{
                borderBottom: `1px solid ${theme.HeaderSelectedText}`,
            },
        }
    }
})


class DropdownSelect extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            value: null,
            options:[]
        }
    }

    componentDidMount(){
        this.updateSelectOptions();
    }

    componentDidUpdate(prevProps){
        if(!isEqual (prevProps.data,this.props.data) || !isEqual(this.props.selectedValues,prevProps.selectedValues)){
            this.updateSelectOptions();
        }
    }

    updateSelectOptions = () => {
        const options = this.props.data;
        this.setState({
            options,
            value: options.filter(option => this.props.selectedValues && this.props.selectedValues.includes(option.label))
        },this.onChange)
    }


    handleChange = (value) => {
        this.setState({
            value
        },this.onChange)
    }

    onChange = () => {
        this.props.onChange(this.state.value);
    }


    filterOption = (option, filterValue) => {
        return option.label && (option.label.toString().includes(filterValue.toString()) || option.label.toString().toUpperCase().includes(filterValue.toString().toUpperCase()));
    }

    render(){
        const { classes } = this.props;
        return (
            <Select
                isMulti={this.props.multipleSelection}
                value={this.state.value}
                onChange={this.handleChange}
                options={ this.state.options}
                classNamePrefix={"select"}
                className={`${classes.reactSelect} ${Array.isArray(this.state.value) && this.state.value.length > 0 ? classes.multiValueApplied : ""}`}
                menuPlacement="auto"
                menuPosition="fixed"
                filterOption={this.filterOption}
                placeholder={`Select ${this.props.fieldName || ""}`}
                closeMenuOnSelect={false}
                components = {{
                    DropdownIndicator: props => <ArrowDropDown {...props.innerProps} className={classes.iconStyle} />,
                    ClearIndicator :props => <Clear {...props.innerProps} className={classes.iconStyle} />
                }}
            />
        )
    }
}

export default withStyles(style)(DropdownSelect);